module.exports = __webpack_public_path__ + "static/media/keyman-db-banner-1@2x.330b0833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyman-db-banner-1@2x.png
// module id = 1283
// module chunks = 1